var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-text-field",
    _vm._g(
      _vm._b(
        {
          attrs: { rules: _vm.localRules },
          scopedSlots: _vm._u(
            [
              _vm.label && !_vm.$slots.label
                ? {
                    key: "label",
                    fn: function () {
                      return [
                        _vm.required
                          ? _c("span", { staticClass: "required-symbol" }, [
                              _vm._v("\n            *\n        "),
                            ])
                          : _vm._e(),
                        _vm._v("\n\n        " + _vm._s(_vm.label) + "\n    "),
                      ]
                    },
                    proxy: true,
                  }
                : null,
              _vm._l(_vm.$scopedSlots, function (_, name) {
                return {
                  key: name,
                  fn: function (slotData) {
                    return [_vm._t(name, null, null, slotData)]
                  },
                }
              }),
            ],
            null,
            true
          ),
        },
        "v-text-field",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm._v(" "),
      _vm._l(_vm.$slots, function (_, name) {
        return _vm._t(name, null, { slot: name })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }